﻿(function () 
{
    var slider;

    function initSlider() 
    {
        var container = document.querySelector('.whychoose-carousel');

        if (window.innerWidth > 767.98) 
        {
            if (container && !slider) 
            {
                slider = tns({
                    container: '.whychoose-carousel',
                    loop: false,
                    autoplay: false,
                    nav: false,
                    lazyload: true,
                    useLocalStorage: false,
                    controlsContainer: ".whychoose-controls",

                    responsive: {
                        768: {
                            fixedWidth: 330,
                            mouseDrag: true,
                            gutter: 20,
                            swipeAngle: false,
                            slideBy: "page",
                            controls: true,
                            speed: 400,
                            axis: "horizontal"
                        }
                    },
                    onInit: function () 
                    {
                        container.classList.add("init");
                    }
                });
            }
        }
        else 
        {
            if (slider) 
            {
                slider.destroy(); // Destroy slider when under 768px
                slider = null;
            }
        }
    }

    initSlider();
    window.addEventListener('resize', initSlider);

})();
